import ImagePlaceholder from '../atoms/ImagePlaceholder'
import css from './LocationCard.module.scss'

export default function LocationCard({ location }) {
	return (
		<div className={css['card']}>
			{/* <div className={css["bg"]} /> */}
			{/* <div className={css["details"]}> */}
			{/* <h4>Store</h4> */}
			{/* <img
                src={location?.businessLogo}
                width="40px"
                height="40px"
                alt="store logo"
            /> */}

			<ImagePlaceholder
				src={location?.businessLogo}
				size='40px'
				alt='logo'
				iconName='fad fa-store'
			/>
			<h5>{location.businessName}</h5>
			{/* </div> */}
		</div>
	)
}
